import assets, { getDay } from "../assets"
import LeftBanner from "./explorationZone/LeftBanner"
import LeftMonitorPopup from "./explorationZone/LeftMonitor"
import RightBanner from "./explorationZone/RightBanner"
import RightMonitorPopup from "./explorationZone/RightMonitor"

const dismissStyle = {
	height: "3.4%",
	left: "auto",
	top: "17%",
	width: "2.5%",
	right: "8%"

}
const dismissHTML = ""

const modalOverrides = { 
	dismissAnimation: false, 
	dismissStyle, 
	dismissHTML, 
	style: {
		background: "none",
		backdropFilter: "none"
	} 
}


export default () => {

	const day = getDay()
	const closeOverwriteLS = assets.exploration_zone.popups.leftScreen[day].closeBtnOverwrite || {}
	const closeOverwriteRS = assets.exploration_zone.popups.rightScreen[day].closeBtnOverwrite || {}
	const leftBoardClose = day > 2 ? {
		top: "21.5%",
		height: "5.4%"
	} : {}

	return {
		background: assets.exploration_zone.df[day],
		extras: <>
			{/* <div style={{
					top: "20.5%", 
					left: ".9%", 
					width: "23.11%", 
					height: "28.2%",
					position: "absolute", 
			}}>
				<img src="/frontend/dist/isf-2025/Screen1.png" style={{
					width: "110.3%", 
					height: "100%",
					transform: "perspective(1500px) rotateY(11deg) skewY(2.4deg)",
					transformOrigin: "left"
				}} />
			</div>
			<div style={{
					top: "70.7%", 
					left: "5.8%", 
					width: "8.11%", 
					height: "22%",
					position: "absolute", 
			}}>
				<img src="/frontend/dist/isf-2025/leftboard.png" style={{
					width: "106.3%", 
					height: "97%",
					transform: "perspective(1500px) rotateY(19deg) skewY(-1deg) skewX(0.2deg) rotateX(3.3deg)",
					transformOrigin: "top"
				}} />
			</div>

			<div style={{
					top: "20.5%", 
					right: ".9%", 
					width: "25.3%", 
					height: "28.3%",
					position: "absolute", 
			}}>
				<img src="/frontend/dist/isf-2025/Screen1.png" style={{
					width: "100%", 
					height: "100%",
					transform: "perspective(1500px) rotateY(350deg) skewY(-2.4deg)",
					transformOrigin: "right"
				}} />
			</div>

			<div style={{
					top: "70.7%", 
					right: "5.8%", 
					width: "8.3%", 
					height: "22%",
					position: "absolute", 
			}}>
				<img src="/frontend/dist/isf-2025/rightboard.png" style={{
					width: "106.3%", 
					height: "97%",
					transform: "perspective(1500px) rotateY(-19deg) skewY(1deg) skewX(-0.2deg) rotateX(-3.3deg)",
					transformOrigin: "top"
				}} />
			</div> */}

			<iframe src={assets.exploration_zone.video} style={{
                position: "absolute",
                width: "49.7%",
				aspectRatio: "16/9",
                top: "5.55%",
                left: "25.1%",
                border: "0",
            }} />
		</>,
		links: [
			{
				height: "29%",
				label: "Build resilience",
				left: ".5%",
				top: "21%",
				width: "24%",
				modalOverrides: {
					...modalOverrides,
					dismissStyle: {
						...modalOverrides.dismissStyle,
						...closeOverwriteLS
					}
				},
				modal: <LeftMonitorPopup />
			},
			{
				height: "29%",
				label: "ISF Services",
				left: "75.5%",
				top: "21%",
				width: "24%",
				modalOverrides: {
					...modalOverrides,
					dismissStyle: {
						...modalOverrides.dismissStyle,
						...closeOverwriteRS
					}
				},
				modal: <RightMonitorPopup />
			},
			{
				height: "29%",
				label: "Today's podcast",
				left: "5%",
				top: "69.7%",
				width: "11%",
				modalOverrides: {
					...modalOverrides,
					dismissStyle: {
						...dismissStyle,
						...leftBoardClose,
						height: "5.4%"
					}
				},
				modal: <LeftBanner />
			},
			{
				height: "29%",
				label: "Maximise your membership",
				left: "85%",
				top: "69.7%",
				width: "11%",
				modalOverrides: {
					...modalOverrides,
					dismissStyle: {
						height: "3.4%",
						left: "auto",
						top: "11.2%",
						width: "2.5%",
						right: "8.5%"
					}
				},
				modal: <RightBanner />
			},
			{
				height: "7.3%",
				label: "Back to Atrium",
				href:"/atrium",
				left: "42.9%",
				top: "89.7%",
				width: "13%"
			},
		],
		name: "exploration-zone",
	}
}
